import {
  EditorColorScheme,
  PortalBgType,
  PortalBorderType,
  PortalShadowType,
  PortalTextType,
  PortalThemeColors,
  TailwindCommonPalette,
  TailwindExtraPalette,
} from '@nx-frontend/shared/types';

export const ThemeLightPurple: PortalThemeColors = {
  key: 'light_purple',
  iconSet: 'default',
  name: 'The Light Purple',
  icon: '/assets/img/icon-light.svg',
  thumbnail: '/assets/img/themes/light-purple/light-purple.png',
  preview: '/assets/img/themes/light-purple/light-purple-preview-full.png',
  description: 'Simple yet elegant theme accentuated by soft lavender hues',
  logo: '/assets/img/default-logo.svg',
  editorColor: EditorColorScheme.LIGHT,
  [PortalBgType.HEADER]: [TailwindCommonPalette.PURPLE_100, TailwindCommonPalette.WHITE, ['bg-gradient-to-b']],
  [PortalBgType.HEADER_MENU]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.BODY]: [TailwindCommonPalette.WHITE],
  [PortalBgType.FOOTER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.PRIMARY]: [TailwindCommonPalette.PURPLE_500],
  [PortalBgType.SECONDARY]: [TailwindCommonPalette.PURPLE_500],
  [PortalTextType.HERO_TEXT]: [TailwindCommonPalette.ZINC_900],
  [PortalBgType.GREETING_1]: [TailwindCommonPalette.ZINC_900],
  [PortalBgType.GREETING_2]: [
    TailwindCommonPalette.FUCHSIA_500,
    TailwindCommonPalette.INDIGO_600,
    ['bg-gradient-to-r'],
  ],
  [PortalBgType.SURFACE]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_DISABLE]: [TailwindCommonPalette.GRAY_50],
  [PortalBorderType.SURFACE_DISABLE]: [TailwindCommonPalette.GRAY_400],
  [PortalTextType.SURFACE_DISABLE]: [TailwindCommonPalette.GRAY_400],
  [PortalBgType.SURFACE_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBgType.SURFACE_VARIANT]: [TailwindCommonPalette.PURPLE_100],
  [PortalBgType.SURFACE_INNER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.PURPLE_200],
  [PortalBgType.SURFACE_INNER_VARIANT_HOVER_2]: [TailwindCommonPalette.PURPLE_200],
  [PortalBgType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.PURPLE_100],
  [PortalBgType.HEADER_HOVER]: [TailwindCommonPalette.PURPLE_200],
  [PortalBgType.BODY_HOVER]: [TailwindCommonPalette.PURPLE_200],
  [PortalBgType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.PURPLE_100],
  [PortalBgType.SURFACE_INNER_HOVER_2]: [TailwindExtraPalette.PURPLE_50],
  [PortalBgType.PRIMARY_HOVER]: [TailwindCommonPalette.PURPLE_600],
  [PortalBgType.SECONDARY_HOVER]: [TailwindCommonPalette.PURPLE_600],
  [PortalBgType.TOOLTIP]: [TailwindCommonPalette.WHITE],
  [PortalBgType.FOOTER_LINE]: [TailwindCommonPalette.PURPLE_200, TailwindCommonPalette.PURPLE_500],
  [PortalBgType.FOOTER_DIVIDER]: [TailwindCommonPalette.GRAY_300],
  [PortalBgType.FILL_SURFACE]: [TailwindCommonPalette.GRAY_500],
  [PortalBgType.FILL_SURFACE_2]: [TailwindCommonPalette.BLACK],
  [PortalBgType.FOOTER_LINKS]: [TailwindCommonPalette.BLACK],
  [PortalBgType.FOOTER_LINKS_HOVER]: [TailwindCommonPalette.GRAY_500],
  [PortalBgType.HEADER_LINKS]: [TailwindCommonPalette.PURPLE_100],
  [PortalTextType.SURFACE]: [TailwindCommonPalette.BLACK],
  [PortalTextType.SURFACE_2]: [TailwindCommonPalette.BLACK],
  [PortalTextType.SURFACE_3]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.SURFACE_VARIANT]: [TailwindCommonPalette.BLACK],
  [PortalTextType.SURFACE_VARIANT_2]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.SURFACE_INNER]: [TailwindCommonPalette.BLACK],
  [PortalTextType.SURFACE_INNER_2]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.BLACK],
  [PortalTextType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.SECONDARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.HEADER]: [TailwindCommonPalette.BLACK],
  [PortalTextType.HEADER_HOVER]: [TailwindCommonPalette.BLACK],
  [PortalTextType.BODY]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.BODY_VARIANT]: [TailwindCommonPalette.PURPLE_600],
  [PortalTextType.FOOTER]: [TailwindCommonPalette.BLACK],
  [PortalTextType.FOOTER_2]: [TailwindCommonPalette.GRAY_500],
  [PortalTextType.FOOTER_HOVER]: [TailwindCommonPalette.PURPLE_600],
  [PortalTextType.TOOLTIP]: [TailwindCommonPalette.BLACK],
  [PortalTextType.PRIMARY]: [TailwindCommonPalette.PURPLE_500],
  [PortalTextType.ON_PRIMARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY_HOVER]: [TailwindCommonPalette.PURPLE_600],
  [PortalShadowType.MAIN]: [TailwindCommonPalette.GRAY_50],
  [PortalShadowType.HOVER]: [TailwindCommonPalette.PURPLE_50],
  [PortalShadowType.SEARCH]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_VARIANT]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_INNER]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.FOOTER]: [TailwindCommonPalette.PURPLE_500],
  [PortalBorderType.SURFACE_HOVER]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.PRIMARY]: [TailwindCommonPalette.PURPLE_500],
  [PortalBorderType.PRIMARY_HOVER]: [TailwindCommonPalette.PURPLE_600],
  [PortalBgType.EDIT_BG]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.EDIT_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBorderType.EDIT_BORDER]: [TailwindCommonPalette.BLACK],
  [PortalBgType.WARN_SURFACE]: [TailwindCommonPalette.AMBER_50],
};

export const ThemeExperimental: PortalThemeColors = {
  ...ThemeLightPurple,
  hidden: true,
  key: 'experimental',
  name: 'Experimental theme',
  imagesBg: { enabled: true, base: { url: '/assets/img/themes/experimental/featured.webp' } },
  [PortalBgType.BODY]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.HEADER]: [TailwindCommonPalette.WHITE, TailwindCommonPalette.TRANSPARENT, ['bg-gradient-to-b']],
  [PortalBgType.SURFACE]: [TailwindCommonPalette.WHITE],
};

export const ThemeExperimental2: PortalThemeColors = {
  ...ThemeExperimental,
  hidden: true,
  key: 'experimental_2',
  name: 'Experimental theme 2',
  imagesBg: { enabled: true, base: { url: '/assets/img/themes/experimental/mountain.jpg' } },
};
